import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

export default function Hero({ onOpenModal }) {
  const { t } = useLanguage();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-brand-black" aria-labelledby="hero-heading">
      <div className="absolute inset-0 z-0 bg-brand-black" />
      
      <div className="relative z-10 flex flex-col items-center text-center px-6 mt-16 max-w-5xl">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.3 }}
          className="flex flex-col items-center"
        >
          <span className="text-white/40 tracking-ultra-wide text-[10px] md:text-xs uppercase mb-8 font-medium">
            {t.tagline}
          </span>
          
          {/* H2: Subsection heading for SEO hierarchy */}
          <h2 id="hero-heading" className="font-serif text-4xl md:text-6xl lg:text-8xl text-white font-light leading-tight tracking-wider">
            {t.headline} <span className="text-brand-gold italic">{t.headlineItalic}</span>
          </h2>

          <div className="flex flex-col items-center justify-center py-10 md:py-16">
            <div className="w-[1px] h-12 md:h-20 bg-gradient-to-b from-brand-gold/60 to-transparent opacity-40"></div>
          </div>

          <button 
            onClick={onOpenModal}
            className="group relative px-12 py-5 border border-brand-gold/40 text-brand-gold font-sans tracking-[0.3em] text-[10px] md:text-xs uppercase transition-all duration-700 hover:border-brand-gold hover:tracking-[0.4em] overflow-hidden"
          >
            <span className="relative z-10">{t.cta}</span>
            <div className="absolute inset-0 w-full h-full bg-brand-gold/5 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-700 origin-center z-0"></div>
          </button>
        </motion.div>
      </div>

      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2, duration: 1 }}
        className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-4"
      >
        <div className="w-[1px] h-16 bg-gradient-to-b from-brand-gold/40 to-transparent"></div>
      </motion.div>
    </section>
  );
}